import React from 'react';
import type { FormField, ThemeConfig } from '../../../types/forms';

interface NPSFieldProps {
  field: FormField;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
  themeConfig?: ThemeConfig;
}

const getNPSColor = (num: number): string => {
  if (num <= 6) return 'bg-red-500 text-white border-red-500';          // Detractors
  if (num <= 8) return 'bg-amber-500 text-white border-amber-500';      // Passives
  return 'bg-green-500 text-white border-green-500';                     // Promoters
};

export const NPSField: React.FC<NPSFieldProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
  themeConfig,
}) => {
  const numbers = Array.from({ length: 11 }, (_, i) => i); // 0-10 (NPS fixo — sem maxRating config)

  return (
    <div>
      {/* mobile-ui.6.C C3: mobile = grid-cols-12 com col-span-2 → linha 1 (0-5) ocupa 12 colunas;
          "6" com col-start-2 desloca meia célula → linha 2 (6-10) PERFEITAMENTE centrada.
          Larguras idênticas por construção. sm: mantém linha única de 11 (3.B). */}
      <div className="grid grid-cols-12 sm:grid-cols-11 gap-2" role="radiogroup" aria-label={field.label}>
        {numbers.map((num) => {
          const isSelected = value === String(num);
          return (
            <button
              key={num}
              type="button"
              role="radio"
              aria-checked={isSelected}
              aria-label={`Nota ${num} de 10`}
              onClick={() => !disabled && onChange?.(String(num))}
              disabled={disabled}
              style={!isSelected && themeConfig?.textColor ? { color: themeConfig.textColor } : undefined}
              className={`
                col-span-2 sm:col-span-1 ${num === 6 ? 'col-start-2 sm:col-start-auto' : ''}
                min-h-11 rounded-lg text-sm font-medium
                transition-all duration-200
                ${isSelected
                  ? getNPSColor(num)
                  : `bg-neutral-900/50 ${themeConfig?.textColor ? '' : 'text-neutral-300'} border ${error ? 'border-red-500' : 'border-neutral-700'} hover:border-neutral-500`
                }
                disabled:opacity-50 disabled:cursor-not-allowed
              `}
            >
              {num}
            </button>
          );
        })}
      </div>
      <div className="flex justify-between mt-2 text-xs text-neutral-500">
        <span>Nada provável</span>
        <span>Muito provável</span>
      </div>
    </div>
  );
};
